import { type StreamForDashboard } from 'Lessons';
import { useContentProgress } from 'ContentProgress';
import { canLaunchLesson } from 'ContentAccess';
import { useCurrentUser } from 'FrontRoyalAngular';

export const useLaunchableLessonsLocalePackIdsByStream = (stream?: StreamForDashboard) => {
    const user = useCurrentUser();
    const { lessonProgressByLocalePackId, streamProgressByLocalePackId } = useContentProgress();

    if (!stream) return [];

    const streamProgress = streamProgressByLocalePackId[stream.localePackId];
    const launchableLessons = stream.lessons.filter(lesson => {
        const lessonProgress = lessonProgressByLocalePackId[lesson.localePackId];
        return canLaunchLesson({ user, lesson, stream, lessonProgress, streamProgress }).canLaunch;
    });

    return launchableLessons.map(lesson => lesson.localePackId);
};
